import Link from 'next/link';
// The company logo: the lockup from the logo pack, still, ink on light and paper on
// dark. `compact` shows the symbol alone for a collapsed sidebar; `tone="paper"`
// pins the paper version for an ink surface such as the site footer.
export function Brand({
  href = '/',
  compact = false,
  tone = 'auto',
  onNavigate,
}: {
  href?: string;
  compact?: boolean;
  tone?: 'auto' | 'paper';
  onNavigate?: () => void;
}) {
  const light = compact ? '/brand/symbol.svg' : '/brand/lockup-light.svg';
  const dark = compact ? '/brand/symbol-dark.svg' : '/brand/lockup-dark.svg';
  const width = compact ? 28 : 146;
  return (
    <Link
      href={href}
      onNavigate={onNavigate}
      aria-label="AddAva home"
      className="inline-flex shrink-0 items-center"
    >
      {tone === 'auto' && (
        <img src={light} alt="AddAva" width={width} height={28} className="dark:hidden" />
      )}
      <img
        src={dark}
        alt={tone === 'auto' ? '' : 'AddAva'}
        width={width}
        height={28}
        className={tone === 'auto' ? 'hidden dark:block' : ''}
      />
    </Link>
  );
}
